import type { ReactNode } from "react";

import { Icon } from "./Icon";
import { Card } from "./Card";
import { Label } from "./misc";

export interface KPICardProps {
  label: string;
  value: ReactNode;
  delta?: string;
  sub?: string;
  good?: boolean;
  bad?: boolean;
  context?: boolean;
}

export function KPICard({
  label,
  value,
  delta,
  sub,
  good,
  bad,
  context,
}: KPICardProps): ReactNode {
  const deltaColor = good
    ? "text-ok"
    : bad
      ? "text-bad"
      : "text-n-500";
  return (
    <Card className="!rounded-3" style={{ padding: "12px 14px" }}>
      <div className="flex items-center justify-between">
        <Label>{label}</Label>
        {context && <Icon name="more" size={12} color="var(--n-400)" />}
      </div>
      <div className="mt-0.5 flex items-baseline gap-2">
        <div className="text-[24px] font-semibold leading-none tracking-[-0.8px] text-n-900 font-display">
          {value}
        </div>
        {delta && (
          <div className={`font-mono text-[11px] font-semibold ${deltaColor}`}>
            {delta}
          </div>
        )}
      </div>
      {sub && <div className="mt-0.5 text-[11px] text-n-500">{sub}</div>}
    </Card>
  );
}
